export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyAHwqvYtLFUsMNKncTQGhmfS82GuqPjvpI',
    authDomain: 'efaktur-75f43.firebaseapp.com',
    databaseURL: 'https://efaktur-75f43.firebaseio.com',
    projectId: 'efaktur-75f43',
    storageBucket: 'efaktur-75f43.appspot.com',
    messagingSenderId: '1061086446986'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts